import { CircleHelpIcon, DollarSignIcon, LockIcon, RefreshCwIcon } from 'lucide-react'

interface InfoItemProps {
  icon: React.ElementType
  title: string
  children: React.ReactNode
}

function InfoItem ({ icon: Icon, title, children }: InfoItemProps) {
  return (
    <div className='flex gap-3'>
      <Icon size={20} className='shrink-0 text-thatch-600' />
      <div>
        <p className='body-bold text-gray-700'>{title}</p>
        <p className='body text-gray-600 mt-1'>{children}</p>
      </div>
    </div>
  )
}

export function BankingInfoSidebar () {
  return (
    <div className='bg-gray-50 rounded-2xl border p-5 space-y-5'>
      <div className='space-y-5'>
        <InfoItem icon={CircleHelpIcon} title='Why connect a bank account?'>
          Thatch automatically pays for your employees' healthcare costs, including premiums and eligible medical expenses, ensuring uninterrupted coverage.
        </InfoItem>

        <InfoItem icon={LockIcon} title='Is my information secure?'>
          We use Plaid, trusted by major banks and apps. Thatch never sees or stores your bank login credentials.
        </InfoItem>

        <InfoItem icon={RefreshCwIcon} title='Can I change my bank later?'>
          Yes, update anytime from your dashboard or by contacting support@thatch.com.
        </InfoItem>

        <InfoItem icon={DollarSignIcon} title='Will I be charged now?'>
          You will not be billed until your employees have been invited.
        </InfoItem>
      </div>
    </div>
  )
}
